
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { ProjectResponse } from 'services/tenantManagementService';
import { propertyOf } from 'utils/propertyOf';
import { sortByString } from 'utils/stringUtil';
import { PROJECTS_SET, PROJECTS_FETCHING, ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_FETCHING, ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_SET, ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_MERGE } from './action';

export const projectReducer = (state = new PersistItemsReducer<ProjectResponse>(), action: PersistItemsActionType<ProjectResponse> | FetchingActionType): PersistItemsReducer<ProjectResponse> => {
	switch (action.type) {
		case PROJECTS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case PROJECTS_SET:
			const { items } = action as PersistItemsActionType<ProjectResponse>;

			const itemsMap: { [id: number]: ProjectResponse } = items.reduce(
                (map: { [id: number]: ProjectResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items: sortByString(items, propertyOf<ProjectResponse>('name')),
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};

export const organizationalUnitManagerProjectReducer = (state = new PersistItemsReducer<ProjectResponse>(), action: PersistItemsActionType<ProjectResponse> | FetchingActionType): PersistItemsReducer<ProjectResponse> => {
	switch (action.type) {
		case ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_SET:
			const { items } = action as PersistItemsActionType<ProjectResponse>;

			const itemsMap: { [id: number]: ProjectResponse } = items.reduce(
                (map: { [id: number]: ProjectResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items: sortByString(items, propertyOf<ProjectResponse>('name')),
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		case ORGANIZATIONAL_UNIT_MANAGER_PROJECTS_MERGE: {
			const { items: newItems } = action as PersistItemsActionType<ProjectResponse>;
			const mergedMap = { ...state.itemsMap };
			for (const item of newItems) {
				if (!mergedMap[item.id]) {
					mergedMap[item.id] = item;
				}
			}
			const mergedItems = sortByString(Object.values(mergedMap).filter(Boolean) as ProjectResponse[], propertyOf<ProjectResponse>('name'));
			return {
				...state,
				items: mergedItems,
				itemsMap: mergedMap
			}
		}
		default:
			return state;
	}
};
